const translations = {
  translation: {
    appTitle: 'Convertidor de Unidades',
    appDescription: 'Convierte unidades instantáneamente en 11 categorías diferentes',
    selectCategory: 'Selecciona una categoría',
    categories: {
      length: 'Longitud',
      mass: 'Masa',
      force: 'Fuerza',
      energy: 'Energía',
      power: 'Potencia',
      pressure: 'Presión',
      temperature: 'Temperatura',
      time: 'Tiempo',
      volume: 'Volumen',
      angle: 'Ángulo',
      area: 'Área',
    },
    units: {
      meter: 'Metro',
      kilometer: 'Kilómetro',
      centimeter: 'Centímetro',
      millimeter: 'Milímetro',
      micrometer: 'Micrómetro',
      nanometer: 'Nanómetro',
      mile: 'Milla',
      yard: 'Yarda',
      foot: 'Pie',
      inch: 'Pulgada',
      nauticalMile: 'Milla Náutica',
      kilogram: 'Kilogramo',
      gram: 'Gramo',
      milligram: 'Miligramo',
      metricTon: 'Tonelada Métrica',
      pound: 'Libra',
      ounce: 'Onza',
      ton: 'Tonelada US',
      stone: 'Stone',
      newton: 'Newton',
      kilonewton: 'Kilonewton',
      poundForce: 'Libra-fuerza',
      kilopoundForce: 'Kilolibra-fuerza',
      dyne: 'Dina',
      joule: 'Julio',
      kilojoule: 'Kilojulio',
      calorie: 'Caloría',
      kilocalorie: 'Kilocaloría',
      wattHour: 'Vatio-hora',
      kilowattHour: 'Kilovatio-hora',
      electronvolt: 'Electronvoltio',
      btu: 'BTU',
      footPound: 'Pie-libra',
      watt: 'Vatio',
      kilowatt: 'Kilovatio',
      megawatt: 'Megavatio',
      horsepower: 'Caballo de fuerza',
      btuPerHour: 'BTU/hora',
      pascal: 'Pascal',
      kilopascal: 'Kilopascal',
      bar: 'Bar',
      atmosphere: 'Atmósfera',
      psi: 'PSI',
      torr: 'Torr',
      mmHg: 'mmHg',
      celsius: 'Celsius',
      fahrenheit: 'Fahrenheit',
      kelvin: 'Kelvin',
      second: 'Segundo',
      millisecond: 'Milisegundo',
      microsecond: 'Microsegundo',
      nanosecond: 'Nanosegundo',
      minute: 'Minuto',
      hour: 'Hora',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      year: 'Año',
      liter: 'Litro',
      milliliter: 'Mililitro',
      cubicMeter: 'Metro Cúbico',
      cubicCentimeter: 'Centímetro Cúbico',
      gallon: 'Galón',
      quart: 'Cuarto',
      pint: 'Pinta',
      cup: 'Taza',
      fluidOunce: 'Onza Líquida',
      tablespoon: 'Cucharada',
      teaspoon: 'Cucharadita',
      degree: 'Grado',
      radian: 'Radián',
      gradian: 'Grado Centesimal',
      arcminute: 'Minuto de Arco',
      arcsecond: 'Segundo de Arco',
      turn: 'Vuelta',
      squareMeter: 'Metro Cuadrado',
      squareKilometer: 'Kilómetro Cuadrado',
      squareCentimeter: 'Centímetro Cuadrado',
      squareMillimeter: 'Milímetro Cuadrado',
      hectare: 'Hectárea',
      acre: 'Acre',
      squareMile: 'Milla Cuadrada',
      squareYard: 'Yarda Cuadrada',
      squareFoot: 'Pie Cuadrado',
      squareInch: 'Pulgada Cuadrada',
    },
    from: 'De',
    to: 'A',
    enterValue: 'Ingrese valor',
    result: 'Resultado',
  },
};

export default translations;
